import {ArrowDown, ArrowRight, Shield, Sparkles} from 'lucide-react'

const AFFILIATE_URL_2 = "https://4c124alqma60jahajoqdtr-80k.hop.clickbank.net"

const HERO_IMAGE = "https://static.lumi.new/3c/3c469197922eecd15d6ca9ba9f9d2b81.png"

export default function HeroSection() {
  return (
    <section className="relative pt-16 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 z-0">
        <img
          src={HERO_IMAGE}
          alt="Healthy fats and nutrition background"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-slate-900/80 via-slate-900/70 to-slate-900/90" />
      </div>

      {/* Affiliate Banner 2 — inside hero top */}
      <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 pt-6 pb-0">
        <a
          href={AFFILIATE_URL_2}
          target="_blank"
          rel="sponsored noopener noreferrer"
          className="group relative flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 rounded-xl border border-white/15 bg-white/10 backdrop-blur-sm px-4 py-3 sm:px-5 sm:py-3.5 hover:bg-white/15 transition-all duration-300"
          aria-label="Sponsored partner offer"
        >
          <div className="flex items-center gap-3 flex-1 min-w-0">
            <div className="flex-shrink-0 w-9 h-9 rounded-lg bg-emerald-500/20 border border-emerald-400/30 flex items-center justify-center">
              <Shield className="w-4 h-4 text-emerald-300" />
            </div>
            <div className="min-w-0">
              <div className="flex items-center gap-1.5 mb-0.5">
                <Sparkles className="w-3 h-3 text-emerald-400" />
                <span className="text-[10px] font-bold tracking-wider uppercase text-emerald-400">Sponsored</span>
              </div>
              <p className="text-xs sm:text-sm text-white/90 font-medium leading-snug truncate">
                Accelerate your results — Expert-recommended nutrition program for faster fat loss.
              </p>
            </div>
          </div>
          <span className="flex-shrink-0 inline-flex items-center gap-1.5 px-4 py-2 bg-emerald-500 text-white text-xs sm:text-sm font-semibold rounded-lg group-hover:bg-emerald-400 transition-colors shadow-md">
            Get Started <ArrowRight className="w-3.5 h-3.5 group-hover:translate-x-0.5 transition-transform" />
          </span>
        </a>
        <p className="text-[10px] text-white/30 text-center mt-1.5">Affiliate disclosure: We may earn a commission at no extra cost to you.</p>
      </div>

      <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 py-16 sm:py-24 lg:py-28">
        <div className="max-w-3xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-emerald-500/15 border border-emerald-400/30 mb-6 animate-fade-in-up opacity-0">
            <Sparkles className="w-3.5 h-3.5 text-emerald-400" />
            <span className="text-xs font-semibold text-emerald-300 tracking-wide uppercase">
              Science-Backed Calculator
            </span>
          </div>

          {/* H1 — SEO Target */}
          <h1 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-extrabold text-white leading-tight mb-5 animate-fade-in-up opacity-0 stagger-1">
            Fat Intake Calculator:{" "}
            <span className="text-emerald-400">Calculate Your Daily Fat Requirements</span>
          </h1>

          {/* Sub-headline — SEO */}
          <p className="text-base sm:text-lg lg:text-xl text-gray-300 leading-relaxed mb-8 max-w-2xl animate-fade-in-up opacity-0 stagger-2">
            The most accurate way to calculate fat grams per day and optimize your fat requirement for weight loss.
            Powered by the Mifflin-St Jeor equation.
          </p>

          {/* CTA */}
          <div className="flex flex-col sm:flex-row gap-3 animate-fade-in-up opacity-0 stagger-3">
            <a
              href="#calculator"
              className="inline-flex items-center justify-center gap-2 px-6 py-3.5 bg-emerald-500 text-white font-semibold rounded-xl hover:bg-emerald-600 transition-all shadow-lg hover:shadow-emerald-500/25 hover:-translate-y-0.5"
            >
              Calculate My Fat Intake
              <ArrowDown className="w-4 h-4 animate-bounce" />
            </a>
            <a
              href="#education"
              className="inline-flex items-center justify-center px-6 py-3.5 bg-white/10 text-white font-medium rounded-xl hover:bg-white/20 transition-all border border-white/20"
            >
              Learn How It Works
            </a>
          </div>

          {/* Trust indicators */}
          <div className="flex flex-wrap gap-6 mt-10 animate-fade-in-up opacity-0 stagger-4">
            {[
              { num: "50K+", label: "Calculations" },
              { num: "99%", label: "Accuracy" },
              { num: "Free", label: "Forever" },
            ].map((stat) => (
              <div key={stat.label} className="flex items-center gap-2">
                <span className="text-xl font-bold text-emerald-400">{stat.num}</span>
                <span className="text-sm text-gray-400">{stat.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Bottom fade */}
      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-white to-transparent z-10" />
    </section>
  )
}
